<!--
 * @Descripttion:
 * @Author: liang
 * @Date: 2021-05-10 16:57:24
 * @LastEditors: liang
 * @LastEditTime: 2021-10-13 17:05:41
-->
<template>
  <div class="collapse">
    <div class="planTitle">
      <span class="planText1">全部课程</span>
      <!-- <span class="planText2">（共21节）</span> -->
    </div>
    <div class="topinfo">
      <el-card>
        <h3>今日上课时长</h3>
        <div class="count"><b>{{Math.ceil(topinfo.studyDurationTotal/60)}}</b>分钟</div>
      </el-card>
      <el-card>
        <h3>我的课程总数</h3>
        <div class="count"><b>{{topinfo.myCoursesCount}}</b>个</div>
      </el-card>
      <el-card>
        <h3>单位课程总数</h3>
        <div class="count"><b>{{topinfo.unitCoursesCount}}</b>个</div>
      </el-card>
    </div>
    <el-collapse v-if="courseList.length>0" v-model="activeNames" @change="handleChange" style="height:100%;" accordion>
      <el-collapse-item  :name="item.teachingId" v-for="item in courseList" :key="item.id">
        <template slot="title">
         <i style="font-weight:bold;padding-right:4px;font-size:16px" class="el-icon-collection"></i> {{item.teachingName}}
         <el-button @click.stop="todetail(item)" size="mini" style="position:absolute;right:340px;top:9px" type="primary" icon="el-icon-s-promotion" plain>前往课程</el-button>
        <div class="progress" style="position:absolute;right:40px;top:0">学习进度：<el-progress style="width:200px;display:inline-block"  :stroke-width="10" :percentage="item.teachRate"></el-progress></div>
        </template>
        <!-- <div class="progress">学习进度：<el-progress style="width:200px;display:inline-block"  :stroke-width="10" :percentage="item.teachRate"></el-progress></div> -->
        <ul class="kczj" v-loading='sectionload'>
                <li v-for="data in sectionList" :key="data.id">
                  <div class="name">
                    <i class="el-icon-video-play"></i
                    ><span>{{data.teachingTitle}} <el-tag style="margin-left:20px" v-if="data.isComplete==1" size="small" effect="plain" type="success">已完成</el-tag></span>
                  </div>
                  <div class="see" @click='seevideo(data)'>观 看</div>
                </li>
              </ul>
      </el-collapse-item>
    </el-collapse>
    <div class="pagination" v-if="courseList.length">
            <el-pagination
              background
              :current-page="cForm.page"
              :page-size=10
              layout="prev, pager, next"
              :total="cTotal"
              @current-change="cPageHandle"
            ></el-pagination>
          </div>
  </div>
</template>

<script>
// import plan from './plan'
export default {
  name: 'plan',
  data () {
    return {
      activeNames: null,
      sectionList: [],
      courseList: [],
      sectionload: false,
      cForm: {
        page: 1
      },
      cTotal: 0,
      sTotal: 0,
      minioUrl: '',
      tid: '',
      topinfo: {
        myCoursesCount: '',
        unitCoursesCount: '',
        studyDurationTotal: ''
      }
    }
  },
  // mounted () {
  //   this.minioUrl = process.env.VUE_APP_minio
  //   this.getCourse()
  //   this.getTopinfo()
  // },
  watch: {
    $route: {
      handler (to) {
        if (to.path === '/myplan') {
          this.minioUrl = process.env.VUE_APP_minio
          this.getCourse()
          this.getTopinfo()
        }
      },
      immediate: true
    }
  },
  components: {
  },
  methods: {
    getCourse () {
      this.$get('/client/personalCenter/studyRecordsPage', this.cForm).then(res => {
        if (res.code === 0) {
          this.courseList = res.data.list
          this.cTotal = res.data.total
          if (res.data.list.length > 0) {
            if (!this.activeNames) {
              // 默认第一个
              this.activeNames = res.data.list[0].teachingId
              this.handleChange(res.data.list[0].teachingId)
            } else {
              // 有选择的下拉就打开那个
              this.handleChange(this.activeNames)
            }
          }
        }
      })
    },
    todetail (item) {
      this.$router.push({ path: '/detail', query: { selectId: item.teachingtype, tid: item.teachingId, tName: item.teachingName } })
    },
    getTopinfo () {
      this.$post('/client/personalCenter/statistics?ssCity=' + localStorage.getItem('citycode') + '&ssProvince=130000').then(res => {
        if (res.code === 0) {
          this.topinfo = res.data
        }
      })
    },
    handleChange (val) {
      this.tid = val
      if (val.length > 0) {
        this.sectionload = true
        this.$get('/client/personalCenter/selectTeachingInfoList/' + val).then(res => {
          this.sectionload = false
          if (res.code === 0) {
            this.sectionList = res.data
          // this.sTotal = res.data.total
          }
        })
      }
    },
    cPageHandle (val) {
      this.cForm.page = val
      this.getCourse()
    },
    seevideo (item) {
      this.$get('/client/personalCenter/videoPlaybackVerify/' + this.tid).then(res => {
        if (res.code === 0) {
          this.$store.dispatch('setIsAddCourse', true)
          this.$router.push({ path: '/video', query: { vurl: process.env.VUE_APP_alioss + item.teachingUrl, tid: this.tid, title: item.teachingTitle, selectId: '', id: item.id } })
        }
      })
    }
  }
}
</script>
<style scoped>
 .planTitle{
    margin-bottom: 15px;
  }
  .planTitle .planText1{
    font-size: 22px;
    font-weight: bold;
  }
  .planTitle .planText2{
    font-size: 14px;
  }
  .collapse{padding-left: 20px;}
  .pagination{text-align: right;padding-top: 20px;}
  .kczj li {
  height: 60px;
  line-height: 60px;
  background: #ddd;
  margin-top: 15px;
  overflow: hidden;
  cursor: pointer;
}
.kczj li:first-child{margin: 0;}
.kczj li:hover {
  background: #ccc;
}
.kczj li .name {
  padding-left: 20px;
  display: flex;
  align-items: center;
  float: left;
}
.kczj li i {
  font-size: 24px;
  margin-right: 5px;
}
.kczj li .see {
  margin-top: 15px;
  margin-right: 20px;
  float: right;
  background: #f01414;
  width: 100px;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  font-size: 15px;
  color: #fff;
  height: 30px;
}
.topinfo{display: flex;margin-bottom: 15px;}
.topinfo .el-card {flex: 1;height: 130px;overflow: hidden;text-align: center;}
.topinfo .el-card:nth-child(2){margin: 0 10px;}
.topinfo h3{font-weight: normal;font-size: 18px;padding: 10px 0}
.topinfo .count b{font-size: 28px;font-weight: normal;padding-right: 3px;}
/* .progress{border: 1px solid #ddd;padding:10px;} */
div/deep/ .el-collapse-item__header{padding-left: 10px;position: relative;}
/* div/deep/.el-collapse-item__header.is-active{} */
</style>
